module.exports = __webpack_public_path__ + "static/media/amazon-music-logo.c0b35672.png";